"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertUnreachable = exports.assertIsDefinedAndNonEmpty = exports.assertIsNonEmpty = exports.assertIsDefined = exports.makeAssert = void 0;
const predicates_1 = require("./predicates");
function makeAssert(predicate, defaultThrowMsg) {
    return function asserter(value, throwMsg) {
        if (!predicate(value)) {
            throw new Error(throwMsg !== null && throwMsg !== void 0 ? throwMsg : defaultThrowMsg);
        }
    };
}
exports.makeAssert = makeAssert;
/**
 * Type assertion that will throw with throwMsg when value is null or undefined
 *
 * Useful with Typescript when you're pretty sure the value will be defined and want to throw when it's not and have type inference correctly know the value is defined after this call.
 * @param value a value that could be null or undefined
 * @param throwMsg {string} an optional more specific message that will be passed to the error constructor when the value is null or undefined
 * @throws This function will throw whenever `value` is `null` or `undefined`
 * @example
 * function example(value: string | null | undefined) {
 * assertIsDefined(value);
 * if (value.length !== 0) { // Typescript won't complain here
 *   // do stuff with string value here
 * }
 * }
 */
exports.assertIsDefined = makeAssert(predicates_1.isDefined, 'Value should be defined');
/**
 * Type assertion that will throw with throwMsg when value is null or undefined or empty
 *
 * Useful with Typescript when you're pretty sure the value will be defined and non empty, and want to throw when it's not and have type inference correctly know the value is defined after this call.
 * @param value a nullable array or string
 * @param throwMsg {string} an optional more specific message that will be passed to the error constructor when the value is null or undefined
 * @throws This function will throw whenever `value` is `null` or `undefined` or empty
 * @example
 * function example(value: string[] | string | null | undefined) {
 * assertIsDefinedAndNonEmpty(value);
 * // value is guaranteed to be defined and non empty here
 * }
 */
exports.assertIsNonEmpty = makeAssert(predicates_1.isNonEmpty, 'Value should be defined and non empty');
/**
 * Type assertion that will throw with throwMsg when value is null or undefined or empty
 *
 * Useful with Typescript when you're pretty sure the value will be defined and non empty, and want to throw when it's not and have type inference correctly know the value is defined after this call.
 * @param value a value that could be null or undefined or empty
 * @param throwMsg {string} an optional more specific message that will be passed to the error constructor when the value is null or undefined
 * @throws This function will throw whenever `value` is `null` or `undefined`
 * @example
 * function example(value: string[] | string | null | undefined) {
 * assertIsDefinedAndNonEmpty(value);
 * // value is guaranteed to be defined and non empty here
 * }
 * @deprecated Use {@link assertIsNonEmpty} instead
 */
exports.assertIsDefinedAndNonEmpty = exports.assertIsNonEmpty;
/**
 * Function that should always be called in `default` `switch` on union type to make sure we have complete cases implementations and have Typescript notify you of missing cases when union type changes
 * @param _value {never} the value on which the `switch` is done
 * @param comment {string} a helpful comment for developers to understand what is happening
 * @throws This function will throw whenever it's called at runtime. It is used to detect when you add new values to your union type.
 * @example
 * function example(value: 'A' | 'B') {
 * switch(value) {
 * case 'A': break;
 * case 'B': break;
 * default: assertUnreachable(value, 'Unhandled new value in union type');
 * }
 * }
 */
function assertUnreachable(_value, comment) {
    throw new Error(comment);
}
exports.assertUnreachable = assertUnreachable;
//# sourceMappingURL=assertions.js.map